import React from 'react';
import { LoadingComponentProps } from 'react-loadable';

import LoadingSection from './LoadingSection';

export function LoadableLoadingSection({
  error,
  pastDelay,
}: LoadingComponentProps) {
  if (error) {
    throw error;
  }

  if (pastDelay) {
    return <LoadingSection delay={0} />;
  }

  return null;
}
